module.exports = __webpack_public_path__ + "img/04-bf3b63.png";